import React, { Component } from "react"
import axios from "axios"
import AxiosConfig from "../../../../utilities/AxiosConfig"
import AccessControl from "../../../../components/common/AccessControl"
import { shouldAllowAccess } from "src/utilities/helper"
import { Button, Modal, Spinner } from "react-bootstrap"
import UserHistory from "./UserAdminSections/UserHistory/UserHistory"
import UserSecure from "./UserAdminSections/UserSecure/UserSecure"
//@ts-ignore
import DateTime from "react-datetime"
import moment from "moment"
import MsalAuth from "../../../../utilities/msalAuth"
import queryParams from "./EmployeeParams"
import EmployeeDataTypes from "../../Types/EmployeeTypes"
import ReferenceTypes from "../../Types/ReferenceTypes"
import snackBar from "../../../../utilities/snackBar/SnackBar"
import reggie from "../../../../utilities/Reggie"
import UserAdminTopRightControls from "./UserAdminUtilities/UserAdminTopRightControls/UserAdminTopRightControls"
import EmployeeActive from "./EmployeeActive/EmployeeActive"
import EmployeeInfo from "./UserAdminSections/EmployeeInfo/EmployeeInfo"
import CompanyInfo from "./UserAdminSections/CompanyInfo/CompanyInfo"
import EmploymentStatus from "./UserAdminSections/EmploymentStatus/EmploymentStatus"
import { isEmployeeInPayRateScope } from "src/components/vault77/payRateHistory/api/payRateHistory.api"
import isValidDomain from "src/utilities/isValidDomain"
import "./UserAdmin.css"

interface UAProps {
    employee: EmployeeDataTypes
    userId: any
    reference: ReferenceTypes | any
    hasEdits: Function
    employeeBackround: any
    updadeList?: Function
    singleDetail?: string
    readOnly: boolean
    doublePanelRef: any
    mangaeParentState: Function
}

type UATypes = {
    eventType: string
    employee: EmployeeDataTypes | any
    isDirty: boolean
    canSave: boolean
    secureIsDirty: boolean
    secureInScope: boolean
    secureScopeChecking: boolean
    validEmail: boolean
    loading: boolean
    activatePrompt: boolean
    deactivatePrompt: boolean
    secureIsOpen: boolean
    cantSaveReasons: Array<string>
}

class UserAdmin extends Component<UAProps, UATypes> {

    index = -1
    copy: any = {}
    secureRef = React.createRef<UserSecure>()
    //[3] is an alias
    requiredPairs = [
        ["JobTitle", "JobTitleEffectiveDate"],
        ["LocationCode", "LocationCodeEffectiveDate"],
        ["HomeProfitCenter", "ProfitCenterEffectiveDate"],
        ["EmploymentStatus", "EmploymentStatusEffectiveDate"],
        ["PayType", "PayTypeEffectiveDate"],
        ["UnionCode", "UnionEffectiveDate"],
        ["TerminationReasonId", "TerminationDate"],
        ["TerminationDate", "TerminationReasonId", "Reason for Separation"]
    ]

    constructor(props: any) {
        super(props)
        this.state = {
            eventType: "",
            employee: {},
            isDirty: false,
            canSave: true,
            secureIsDirty: false,
            secureInScope: false,
            secureScopeChecking: false,
            validEmail: false,
            loading: false,
            activatePrompt: false,
            deactivatePrompt: false,
            secureIsOpen: false,
            cantSaveReasons: [],
        }
    }

    componentDidMount() {
        this.setState({ employee: JSON.parse(JSON.stringify(this.props.employee)) })
        this.copy = JSON.parse(JSON.stringify(this.props.employee))
        for (const [key, value] of Object.entries(this.props.employee)) {
            queryParams[key] = value
        }
        if (this.props.employee.WorkEmail) {
            this.validateMail(this.props.employee.WorkEmail)
        } else {
            this.validateMail("")
        }
        this.getEmployeeData()
        // Run the scope check even in read-only mode — the Secure card is a read surface for
        // in-scope viewers (e.g. a USER-ADMIN-VIEWER), not just editors. Editing is gated
        // separately inside the card by the Vault77 write permissions.
        if (!this.props.singleDetail) {
            this.checkPayRateScope()
        }
    }

    checkPayRateScope = async () => {
        this.setState({ secureScopeChecking: true })
        try {
            const inScope = await isEmployeeInPayRateScope(this.props.employee.UserId)
            this.setState({ secureInScope: inScope, secureScopeChecking: false })
        } catch {
            // Fail closed: if the scope check itself errors, don't render pay-rate data.
            this.setState({ secureInScope: false, secureScopeChecking: false })
        }
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
        this.submitCheck()
    }

    getEmployeeData = () => {
        this.setState({ loading: true })
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + this.props.employee.UserId, AxiosConfig.configValue())
            .then(res => {
                let employee = res.data.users[0]
                //clean up empty strings from dirty api data
                //r-18-lint-bk
                //eslint-disable-next-line
                for (const [key, value] of Object.entries(employee)) {
                    if (employee[key] === "") {
                        employee[key] = null
                    }
                }
                if (employee.EmergencyContacts) {
                    employee.EmergencyContacts = employee.EmergencyContacts.slice(Math.max(employee.EmergencyContacts.length - 3, 0))
                }

                for (const [key, value] of Object.entries(employee)) {
                    queryParams[key] = value
                }

                if (this.props.updadeList) {
                    this.props.updadeList(employee)
                }

                this.setState({ loading: false, employee: queryParams })
                this.copy = JSON.parse(JSON.stringify(queryParams))
            }).then(() => {
                this.submitCheck()
            }).catch(err => {
                this.setState({ loading: false })
                //console.log(err)
            })
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    workPhoneMask = (text: string) => {
        const regex = /[a-zA-Z!@#$%^&*_=,\./:;'"\[{}\]<>?\|\\]/g;
        if (regex.test(text)) {
            return text;
        }
        
        let formattedNumber = '';
        const onlyDigits = ('' + text).replace(/\D/g, '');

        if (onlyDigits.length === 10) {
            // format: (xxx) xxx-xxxx
            const match = onlyDigits.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match && match.length === 4) formattedNumber = ['(', match[1], ') ', match[2], '-', match[3]].join('');

            return formattedNumber;
        }
        if (onlyDigits.length === 11) {
            // format: +x (xxx) xxx-xxxx
            const match = onlyDigits.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
            if (match && match.length === 5) formattedNumber = ['+', match[1], ' (', match[2], ') ', match[3], '-', match[4]].join('');

            return formattedNumber;
        }
        if (text == null) {
            formattedNumber = '';

            return formattedNumber;
        }

        return text;
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        if (this.state.eventType === "WorkEmail") {
            this.validateMail(input)
        }
        if(this.state.eventType === "EmployeeNumber" || this.state.eventType === "UserName"){
           input = reggie.joinString(input)
        }
        if (this.state.eventType === "WorkPhone") {
            input = this.workPhoneMask(input);
        }

        let employee = this.state.employee
        let eventType = this.state.eventType
        let eventTypes = Object.keys(employee)
        let temp = employee
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.appendParams([param])
            }
        }
    }

    appendParams = (params: Array<object>) => {
        for (let i = 0; i < params.length; i++) {
            let key = Object.keys(params[i])
            let value = Object.values(params[i])
            if (value[0] !== "") {
                queryParams[key[0]] = value[0]
            } else {
                queryParams[key[0]] = null
            }
        }
        this.setState({ employee: queryParams })
        this.submitCheck()
    }

    undoDate = (eventType: string) => {
        this.appendParams([{ [eventType]: this.copy[eventType] }])
        this.setEventType("")
    }

    validateMail = (mail: string) => {
        this.setState({ validEmail: reggie.validateMail(mail) })
    }

    validateWorkPhone = (phone: string) => {
        // phone is not required, so if it is empty it is valid
        if (phone == null || phone.length === 0) return true;

        // check if there are letters/symbols
        const regex = /[a-zA-Z!@#$%^&*_=,\./:;'"\[{}\]<>?\|\\]/g;        
        if (regex.test(phone)) return false;

        // check length of phone number
        const onlyDigits = ('' + phone).replace(/\D/g, '');
        if (onlyDigits.length < 10 || onlyDigits.length > 11) return false;
    
        return true;
    }

    submitCheck = () => {

        let cantSaveReasons = []
        const required = this.requiredPairs

        for (let i = 0; i < required.length; i++) {
            if (queryParams[required[i][0]] && !queryParams[required[i][1]]) {
                const reason = required[i].length < 3 ? required[i][1] : required[i][2]
                cantSaveReasons.push(reggie.deCamel(reason))
            }
        }

        if (this.hasChanges(this.copy, queryParams) || this.state.secureIsDirty) {
            //more basterdiaztion(task 2657)
            if (!isValidDomain(queryParams.WorkEmail, this.props.reference.validDomains) && `${queryParams.WorkEmail}` !== `${this.copy.WorkEmail}`) {
                cantSaveReasons.unshift("Email is modified and invalid")
                this.setState({ isDirty: true, cantSaveReasons: cantSaveReasons })
                this.props.hasEdits(true)
            } else {
                this.setState({ isDirty: true, cantSaveReasons: cantSaveReasons })
                this.props.hasEdits(true)
            }
            
            // WORK PHONE
            if (!this.validateWorkPhone(queryParams.WorkPhone) && `${queryParams.WorkPhone}` !== `${this.copy.WorkPhone}`) {
                cantSaveReasons.push('Invalid work phone.');
                this.setState({ isDirty: true, cantSaveReasons: cantSaveReasons });
                this.props.hasEdits(true);
            } else {                
                this.setState({ isDirty: true, cantSaveReasons: cantSaveReasons });            
                this.props.hasEdits(true);
            }
        } else {
            this.setState({ isDirty: false, cantSaveReasons: cantSaveReasons })
            this.props.hasEdits(false)
        }
    }

    hasChanges = (a: object, b: object) => {
        if (JSON.stringify(a).toLocaleLowerCase() !== JSON.stringify(b).toLocaleLowerCase()) {
            return true
        }
        return
    }

    countMissing = (arr: Array<string>) => {
        let missing = []
        for (let i = 0; i < arr.length; i++) {
            if (!this.state.employee[arr[i]]) {
                missing.push(arr[i])
            }
        }
        return missing
    }

    toggleModal = (key: string) => {
        let state: any = this.state
        if (!state[key]) {
            state[key] = true
        } else {
            state[key] = false
        }
        this.setState(state)
    }

    copyToClipboard = (str: string | null, snack: string) => {
        if (str) {
            navigator.clipboard.writeText(str)
            snackBar({ text: `${snack} Copied to Clipboard`, type: "success", timeout: 3000 })
        } else {
            snackBar({ text: "Could not copy to clipboard", type: "error", timeout: 3000 })
        }
    }

    updateCallback = (employee: EmployeeDataTypes) => {
        this.setState({ employee: employee })
        this.copy = employee
    }

    update = () => {
        if (this.state.secureIsDirty) {
            this.updateSecure()
        }
        if (this.state.isDirty) {
            this.updateEmployee()
            this.updateEmergencyContacts()
        }
    }

    //? updateEmergencyContacts() must be called after this....
    updateEmployee = () => {
        this.setState({ loading: true })
        let employee = this.state.employee
        let rb = JSON.parse(JSON.stringify(employee))
        delete rb.EmergencyContacts
        // Supervisor is editable in the Portal again (Area51 decommission). SupervisorId is the
        // ONE canonical write field — the API binds it and PortalUpdateUser persists it (guarded:
        // 0 keeps the stored value). Strip the two read-only echoes other endpoints add so a stale
        // duplicate can never win JSON.NET's case-insensitive binding over the real value:
        //   SupervisorID — raw DB-cased leak, Supervisor — display name from UserExpanded.
        delete rb.SupervisorID
        delete rb.Supervisor
        rb.SupervisorId = employee?.SupervisorId || 0

        if (this.state.isDirty && employee) {
            axios.post(process.env.REACT_APP_API_URL + "/api/user", rb, AxiosConfig.configValue("min"))
                .then((res) => {
                    const employee = res.data
                    if (employee.ValidationMessage || employee.UserId < 1) {
                        const msg = employee.ValidationMessage ? employee.ValidationMessage : ""
                        snackBar({ text: `Error Updating Employee Info: ${msg}`, type: "error", timeout: 8000 })
                    }
                    this.getEmployeeData()
                })
                .catch(err => {
                    //console.log(err);
                    this.setState({ loading: false })
                    snackBar({ text: "Error Updating Employee Info", type: "error", timeout: 8000 })
                })

        }
    }


    // Saves the secure section (EmployeeSensitiveData) via Vault77. The section manages its own
    // draft/dirty state and clears secureIsDirty + snackBars on success; pay-rate edits are saved
    // immediately inside the pay-rate modal, not here.
    updateSecure = async () => {
        try {
            if (this.secureRef.current) {
                await this.secureRef.current.save()
            }
        } catch (err) {
            // Error is surfaced to the user inside the secure section.
        }
    }

    /*
    This cant be part of the employee object for some reason, seems really dumb to me because they are returned as part of the employee object.
    To add insult to injury the API cant take an array of emergency contacts and doesn"t limit them to 3 as per the mockup so this has to 
    be done recursively in order to ensure they save in the correct order. You will see them limited to rendereing 3 in EmergencyContacts.tsx as well.
    */

    updateEmergencyContacts = () => {

        let contacts = this.state.employee.EmergencyContacts
        let copy = this.copy.EmergencyContacts

        if (contacts.length > 0 && this.index < contacts.length - 1) {
            this.index++
            if (contacts.length > 0 && JSON.stringify(contacts[this.index]) !== JSON.stringify(copy[this.index])) {
                let contact: any = contacts[this.index]
                let rb: any = {}
                if (contact.DeletedDate) {//delete
                    rb.EmployeeEmergencyContactId = contact.EmployeeEmergencyContactId
                    rb.EmployeeId = this.props.employee.UserId
                    rb.EmergencyContactName = contact.EmergencyContactName
                    rb.EmergencyContactPhone = contact.EmergencyContactPhone
                    rb.CreatedDate = contact.CreatedDate
                    rb.CreatedBy = contact.CreatedBy
                    rb.ModifyDate = contact.ModifyDate
                    rb.ModifiedBy = parseInt(this.props.userId)
                    rb.DeletedDate = contact.DeletedDate
                    rb.DeletedBy = parseInt(contact.DeletedBy)
                    rb.DisabledDate = null
                    rb.DisabledBy = null
                } else if (!contact.EmployeeEmergencyContactId && contact.EmergencyContactName) {//create
                    rb.EmployeeEmergencyContactId = null
                    rb.EmployeeId = this.props.employee.UserId
                    rb.EmergencyContactName = contact.EmergencyContactName
                    rb.EmergencyContactPhone = contact.EmergencyContactPhone
                    rb.CreatedDate = moment().format()
                    rb.CreatedBy = parseInt(this.props.userId)
                    rb.ModifyDate = null
                    rb.ModifiedBy = parseInt(this.props.userId)
                    rb.DeletedDate = null
                    rb.DeletedBy = null
                    rb.DisabledDate = null
                    rb.DisabledBy = null
                } else {//edit
                    if (contact.EmergencyContactName) {
                        rb.EmployeeEmergencyContactId = contact.EmployeeEmergencyContactId
                        rb.EmployeeId = this.props.employee.UserId
                        rb.EmergencyContactName = contact.EmergencyContactName
                        rb.EmergencyContactPhone = contact.EmergencyContactPhone
                        rb.CreatedDate = moment().format()
                        rb.CreatedBy = parseInt(this.props.userId)
                        rb.ModifyDate = null
                        rb.ModifiedBy = parseInt(this.props.userId)
                        rb.DeletedDate = null
                        rb.DeletedBy = null
                        rb.DisabledDate = null
                        rb.DisabledBy = null
                    }
                }
                if (Object.keys(rb).length === 12) {
                    axios.post(process.env.REACT_APP_API_URL + "/api/user/CreateOrUpdateEmergencyContactPost", rb, AxiosConfig.configValue("min"))
                        .then(() => {
                            this.updateEmergencyContacts()
                        })
                        .catch((err) => {
                            snackBar({ text: "Error Updating Emergency Contacts", type: "error", timeout: 3000 })
                            // this.setState({ loading: false, isDirty: false })
                            this.props.hasEdits(false)
                            //console.log(err)
                            this.updateEmergencyContacts()
                        })
                } else {
                    this.updateEmergencyContacts()
                }
            } else {
                this.updateEmergencyContacts()
            }
        } else {
            this.index = -1
            // this.setState({ loading: false, isDirty: false })
            this.props.hasEdits(false)
            // snackBar({ text: "Employee Info Updated", type: "success", timeout: 3000 })
        }
    }

    render() {

        let employee = this.state.employee
        const eventType = this.state.eventType
        let singleDetail = this.props.singleDetail
        const readOnly = this.props.readOnly

        // console.log("???emp",employee)

        return (
            <div className="UserAdmin">
                {!singleDetail && !readOnly && <UserAdminTopRightControls
                    employee={employee}
                    updateEmployee={this.update}
                    toggleActivate={this.toggleModal}
                    isDirty={this.state.isDirty}
                    secureIsDirty={this.state.secureIsDirty}
                    loading={this.state.loading}
                    countMissing={this.countMissing}
                    cantSaveReasons={this.state.cantSaveReasons}
                />}
                {/*******************************************************************Activate/Deactivate*******************************************************************/}
                {this.state.activatePrompt && !singleDetail && !readOnly &&
                    <EmployeeActive
                        queryParams={queryParams}
                        togglePrompt={this.toggleModal}
                        activate={true}
                        updateCallback={this.updateCallback}
                    />}
                {this.state.deactivatePrompt && !singleDetail && !readOnly &&
                    <EmployeeActive
                        queryParams={queryParams}
                        togglePrompt={this.toggleModal}
                        activate={false}
                        updateCallback={this.updateCallback}
                    />}
                {/*******************************************************************Employee Information*******************************************************************/}
                <EmployeeInfo
                    employee={employee}
                    copy={this.copy}
                    userId={this.props.userId}
                    reference={this.props.reference}
                    loading={this.state.loading}
                    countMissing={this.countMissing}
                    handleChange={this.handleChange}
                    appendParams={this.appendParams}
                    setEventType={this.setEventType}
                    copyToClipboard={this.copyToClipboard}
                    singleDetail={this.props.singleDetail}
                    readOnly={readOnly}
                />
                {/*******************************************************************Company Information*******************************************************************/}
                <CompanyInfo
                    employee={employee}
                    copy={this.copy}
                    reference={this.props.reference}
                    loading={this.state.loading}
                    countMissing={this.countMissing}
                    handleChange={this.handleChange}
                    setEventType={this.setEventType}
                    appendParams={this.appendParams}
                    validEmail={this.state.validEmail}
                    singleDetail={this.props.singleDetail}
                    readonly={readOnly}
                />
                {/*******************************************************************Employment Status*******************************************************************/}
                <EmploymentStatus
                    employee={employee}
                    copy={this.copy}
                    reference={this.props.reference}
                    loading={this.state.loading}
                    countMissing={this.countMissing}
                    handleChange={this.handleChange}
                    setEventType={this.setEventType}
                    appendParams={this.appendParams}
                    employeeBackround={this.props.employeeBackround}
                    singleDetail={this.props.singleDetail}
                    readOnly={readOnly}
                />
                {/*******************************************************************User Secure/History*******************************************************************/}
                {/* Targets mirror the API's Vault77Permissions checks (formerly a single legacy
                    HR:ELEV gate with no server-side counterpart):
                    - UserSecure renders for EITHER read permission and keeps its full card shape
                      inside: the pay-rate value needs Vault77.Read.PayRate, the PII values need
                      Vault77.Read.EmployeeSensitiveData — without PII-read the fields render as
                      read-only star masks. So a manager (ReviewWriter: pay-read only) sees their
                      report's pay rate and starred-out PII, while HR sees real values.
                      secureInScope stays: it's the server's per-employee hierarchy answer
                      (GET payRateHistory/inScope), orthogonal to role targets.
                    - UserHistory reads GET /auditLog → Vault77.Read.DataAccessAudit. */}
                {!singleDetail && employee.WorkingProfitCentersAllowed && this.props.reference && <>
                    {(shouldAllowAccess("Vault77.Read.PayRate")
                        || shouldAllowAccess("Vault77.Read.EmployeeSensitiveData"))
                        && (this.state.secureScopeChecking
                            ? <div className="uac-secure-scope-loading"><Spinner animation="border" variant="secondary" /></div>
                            : this.state.secureInScope && <UserSecure
                                ref={this.secureRef}
                                userId={this.props.employee.UserId}
                                manageParentState={this.manageState}
                                secureIsDirty={this.state.secureIsDirty}
                                readOnly={readOnly}
                                supervisorId={employee.SupervisorId}
                                supervisorName={employee.Supervisor}
                                supervisors={this.props.reference?.supervisors}
                                onSupervisorChange={(id: number, name: string) =>
                                    this.appendParams([{ Supervisor: name }, { SupervisorId: id }])}
                            />)}
                    <AccessControl target="Vault77.Read.DataAccessAudit">
                        <UserHistory
                            userId={this.props.employee.UserId}
                        />
                    </AccessControl>
                </>}
                {/*******************************************************************Handles Effective Dates***************************************************************/}
                {(
                    (eventType === "JobTitleEffectiveDate") ||
                    (eventType === "LocationCodeEffectiveDate") ||
                    (eventType === "ProfitCenterEffectiveDate") ||
                    (eventType === "EmploymentStatusEffectiveDate") ||
                    (eventType === "PayTypeEffectiveDate") ||
                    (eventType === "UnionEffectiveDate") ||
                    (eventType === "TerminationDate"))
                    &&
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                        centered={true}
                    >
                        <DateTime
                            input={false}
                            timeFormat={false}
                            onChange={(date: any) => {
                                this.appendParams([{ [this.state.eventType]: moment(date.valueOf()).format().split("T")[0] }])
                            }}
                        />
                        <Modal.Footer>
                            <div className="UACEffectiveDateModalFooter">
                                <Button variant="secondary" onClick={() => this.undoDate(this.state.eventType)}>Cancel</Button>
                                <Button variant="primary" onClick={() => this.setEventType("")}>Ok</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>}
            </div >
        )
    }
}

export default UserAdmin